// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3XBm_","col":"styles_col__2Iyam"};